import ingeoService from './ingeo'
import { TokenService } from './storage.service'

const vehiculoService = {}


vehiculoService.index = function () {
    const token = TokenService.getToken()
    const requestHeaders = {'Authorization': token}

    return ingeoService.get('vehiculos', {headers: requestHeaders}
     ).then(function (res) {
        return res
    })
}

vehiculoService.route = function (pat, limit) {
    const token = TokenService.getToken()
    const requestHeaders = { 'content-type': 'application/json', 'Authorization': token }
    const requestParams = { limit: limit }

    return ingeoService.get('vehiculos/' + pat + '/coordenadas', {
        headers: requestHeaders,
        params: requestParams
      }
     ).then(function (res) {
        return res
    })
}

vehiculoService.vbat = function (pat) {
    const token = TokenService.getToken()
    const requestHeaders = { 'content-type': 'application/json', 'Authorization': token }
    const requestParams = { limit: 1, var: 'VBATPRN' }

    return ingeoService.get('vehiculos/' + pat + '/feeds', {
        headers: requestHeaders,
        params: requestParams
      }
     ).then(function (res) {
        return res
    })
}
export default vehiculoService;
